module.exports = true;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3659550778/src/~/core-js/library/modules/_library.js
// module id = 5D9A
// module chunks = 6